/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Connect_Invalid_TokenInputs */



/**
* | output |
* | --- |
* | "Invalid Microsoft token. Please restart the Teams Bot." |
*
* @param {Teams_Connect_Invalid_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_connect_invalid_token = /** @type {((inputs?: Teams_Connect_Invalid_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Connect_Invalid_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Microsoft-Token. Bitte starten Sie den Teams Bot neu.")
	return /** @type {LocalizedString} */ ("Invalid Microsoft token. Please restart the Teams Bot.")
});